module.exports = __webpack_public_path__ + "static/img/package.48c6250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/package.png
// module id = M0Mm
// module chunks = 1